import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-message-icon',
    templateUrl: './message-icon.component.html',
    styleUrls: ['./message-icon.component.scss']
})
export class MessageIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 24;
    }
}
